import {Injectable, inject} from '@angular/core';
import {SessionStorageService, UrlService} from '../services';
import {HideHeaderService} from '../services/hide-header.service';
import {ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';

export const BACK_LINK_URL: string = 'backLinkUrl';
export const PDP_URL_QUERY_PARAM: string = 'pdpUrl';
export const BACK_LINK_QUERY_PARAM: string = 'backLink';
export const HIDE_HEADER_PARAM: string = 'hideHeader';
const DCP_HIDE_HEADER_FLAG: string = 'dcp-hide-header-flag';

@Injectable({
  providedIn: 'root',
})
export class UrlParamsGuard {
  private hideHeaderService: HideHeaderService = inject(HideHeaderService);

  constructor(
    private sessionStorageService: SessionStorageService,
    private urlService: UrlService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const urlParams = state.root.queryParams;
    if (urlParams) {
      const backLink: string | null = urlParams[BACK_LINK_QUERY_PARAM];
      const inAppPdpUrl: string | null = urlParams[PDP_URL_QUERY_PARAM];
      const hideHeaderParams: string | null = urlParams[HIDE_HEADER_PARAM];

      if (
        hideHeaderParams &&
        (hideHeaderParams.toLowerCase() === 'true' || hideHeaderParams.toLowerCase() === 'false')
      ) {
        if (!this.sessionStorageService.getItem(DCP_HIDE_HEADER_FLAG)) {
          const hideHeader: boolean = JSON.parse(hideHeaderParams);
          this.hideHeaderService.updateHideHeader(hideHeader);
        }
      }

      const isURLValid: (url: string | null) => boolean = (url: string | null): boolean =>
        !!url && !!this.urlService.sanitizeUrl(url) && this.urlService.isURLDomainTrusted(url);

      const urlToStore: string | null = isURLValid(backLink)
        ? this.urlService.sanitizeUrl(backLink!)!
        : isURLValid(inAppPdpUrl)
          ? this.urlService.sanitizeUrl(inAppPdpUrl!)!
          : null;

      if (urlToStore) {
        this.sessionStorageService.setItem(BACK_LINK_URL, urlToStore);
      } else {
        // clear item so that the PDP URL / BACK LINK URL is set to default
        this.sessionStorageService.removeItem(BACK_LINK_URL);
      }
    }

    return true;
  }
}
